<template>
  <div v-loading="loading">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>新建分析</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体部分 -->
    <div style="border: 1px solid #e3e3e3;width: 75%;padding:2% 8%;margin-left: 10%">
      <el-form ref="groupAddForm" :model="groupAddForm" label-width="160px" style="width:95%;">
<!--        <el-form-item label="是否分组" :required="true">-->
<!--          <el-checkbox v-model="isGroup" @change="handleIsGroup">-->
<!--          </el-checkbox>-->
<!--        </el-form-item>-->
        <el-form-item label="分析名" :required="true">
          <el-input v-model="analyzeName"></el-input>
        </el-form-item>
        <!--        <div v-if="isGroup">-->
        <el-form-item label="选择分组" :required="true">
          <el-checkbox v-model="checkAllGroup" @change="handleCheckAllChange" :indeterminate="isIndeterminate">全选
          </el-checkbox>
          <el-checkbox-group v-model="groupAddForm.groups" @change="groupChooseChange">
            <el-checkbox border :label="item" v-for="item in showGroupSample" class="checkbox-setting"
                         :key="item.groupName" style="overflow:hidden">
              <div style="display: flex;margin-bottom: 8px;justify-items: center">
                  <span :style="'white-space:nowrap;flex:none ;width:'+groupNameMaxLength+'px'">{{
                      item.groupName
                    }}</span>
                <el-tooltip :content="item.simpleNames.join(',')" :disabled="item.simpleNames.length<=4">
                <span style="margin-left:20px">{{
                    '(共包含' + item.simpleNames.length + '个样本)\t' + showGroupExceed(item.simpleNames)
                  }}
                  <span v-if="item.simpleNames.length>=4">...</span>
                </span>
                </el-tooltip>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!--        </div>-->
        <!--        <div v-else>-->
        <!--          <el-form-item label="选择样本" :required="true">-->
        <!--            <div style="display: flex">-->
        <!--              <el-checkbox v-model="checkAllSample" @change="handleCheckAllSample"-->
        <!--                           :indeterminate="isIndeterminateSample">全选-->
        <!--              </el-checkbox>-->
        <!--              <el-input style="width: 200px;margin-left: 20px;" v-model="filterSample"-->
        <!--                        placeholder="搜索样本名">-->
        <!--                <template #suffix>-->
        <!--                  <i class="el-icon-circle-close" @click="clearInput"></i>-->
        <!--                </template>-->
        <!--              </el-input>-->
        <!--            </div>-->
        <!--            <el-checkbox-group v-model="checkedSample" @change="sampleChooseChange">-->
        <!--              <el-row>-->
        <!--                <el-col :span="12" :key="index" v-for="(item, index) in filterSamples" style="padding: 10px 0;">-->
        <!--                  <el-checkbox  :label="item">-->
        <!--                  </el-checkbox>-->
        <!--                </el-col>-->
        <!--              </el-row>-->
        <!--            </el-checkbox-group>-->
        <!--          </el-form-item>-->
        <!--        </div>-->
        <!--        <el-form-item :label="isGroup?'分组颜色':'样本颜色'"-->
        <!--                      v-show="(checkGroup&&isGroup)||(checkedSample.length>0&&!isGroup)">-->
        <!--          <div :style="groupAddForm.groupColor.length>8?'height:400px;overflow-y:auto;':''">-->
        <!--            <div style="display : flex;margin-bottom: 10px;" v-for="(item, index) in groupAddForm.groupColor"-->
        <!--                 :key="item.groupName"-->
        <!--                 draggable="true"-->
        <!--                 @dragstart="handleDragStart($event, item)"-->
        <!--                 @dragover.prevent="handleDragOver($event, item)"-->
        <!--                 @dragenter="handleDragEnter($event, item)"-->
        <!--                 @dragend="handleDragEnd($event, item)">-->
        <!--            <span :style="'white-space:nowrap;flex:none ;width:'+groupNameMaxLength+'px'">-->
        <!--              {{ item.groupName }}-->
        <!--            </span>-->
        <!--              <el-input v-model="item.color" style="width:60%;margin-left: 20px" :key="index + ''"></el-input>-->
        <!--              <div style="text-align: center;display: flex">-->
        <!--                <el-color-picker v-model="item.color" :predefine="predefineColors" style="margin-left: 60px"-->
        <!--                                 :key="index+item.color"-->
        <!--                ></el-color-picker>-->
        <!--                <div v-if="errColor[index]=((!item.color)||(item.color)&&checkIsColor(item.color))"-->
        <!--                     :key="index+item.color+Math.floor(Math.random()*10000 + 1)"-->
        <!--                     class="errMess" style="text-align:center ;color: #f36f70">颜色格式错误或者为空-->
        <!--                </div>-->
        <!--                <el-tooltip content="上移">-->
        <!--                  <el-button :disabled="index===0" size="mini" class="move-up-button" @click="handleMoveUp(item)"><i-->
        <!--                    class="el-icon-top"></i></el-button>-->
        <!--                </el-tooltip>-->
        <!--                <el-tooltip content="下移">-->
        <!--                  <el-button :disabled="index===groupAddForm.groupColor.length-1" size="mini" class="move-up-button"-->
        <!--                             @click="handleMoveDown(item)"><i class="el-icon-bottom"></i></el-button>-->
        <!--                </el-tooltip>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <span style="color: #b2b2b2">-->
        <!--            注：可拖动上方{{ isGroup ? '分组' : '样本' }}颜色中的{{-->
        <!--              isGroup ? '组名' : '样本名'-->
        <!--            }}进行排序，从而调整{{ isGroup ? '组名' : '样本名' }}在分析中图例的顺序</span>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item align-top>-->
        <!--          <template #label>-->
        <!--            <label>OTU出现在所有样本中的最小次数阈值-->
        <!--              <el-tooltip style="cursor: pointer"-->
        <!--                          content="即一行中非0的样本数量大等于这个阈值的OTU才会被保留，小于的话，删除行。默认值为0"-->
        <!--                          placement="top">-->
        <!--                <i class="el-icon-question elIconQuestion"></i>-->
        <!--              </el-tooltip>-->
        <!--            </label>-->
        <!--          </template>-->
        <!--          <div class="input-wrapper">-->
        <!--            <el-input v-model="otuMinTime" name="otuMinTime"-->
        <!--                      v-validate="{number:true}"></el-input>-->
        <!--            <span class="errMess" style="top:80%" v-show="errors.has('otuMinTime')">{{-->
        <!--                errors.first('otuMinTime')-->
        <!--              }}</span>-->
        <!--          </div>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item>-->
        <!--          <template #label>-->
        <!--            <label>OTU最小丰度阈值-->
        <!--              <el-tooltip style="cursor: pointer"-->
        <!--                          content="即一行所有样本的求和，除以矩阵所有数字求和必须大于等于阈值的OTU保留，小于的话，删除行。默认值为0%"-->
        <!--                          placement="top">-->
        <!--                <i class="el-icon-question elIconQuestion"></i>-->
        <!--              </el-tooltip>-->
        <!--            </label>-->
        <!--          </template>-->
        <!--          <el-input v-model="otuMinPercent" name="otuMinPercent"-->
        <!--                    v-validate="{number:true}">-->
        <!--            <template slot="append">%</template>-->
        <!--          </el-input>-->
        <!--          <span class="errMess" v-show="errors.has('otuMinPercent')">{{ errors.first('otuMinPercent') }}</span>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="上传环境因子">-->
        <!--          <el-checkbox v-model="checkedEnv"></el-checkbox>-->
        <!--          <diV v-if="checkedEnv">-->
        <!--            <upload :child-msg="uploadEnvProperty" :show-file-list="false" @callFather="getEnvFile" :dataType="'MATRIX'"-->
        <!--                    :exampleFileName="'Env.txt'"-->
        <!--                    input-placeholder="请上传环境因子文件，格式为txt" :component-style="1" ref="uploadEnvChild"></upload>-->
        <!--          </diV>-->
        <!--        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="resetAnalyze">重 置</el-button>
        <el-button type="success" plain @click="prepareAddAnalyze" style="margin-left: 30px">确 定</el-button>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="isAnalysisOver"
      width="50%"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="closeIsAnalysisOver"
    >
      <div>
        <p> 抱歉，您的分析数已达20条，不能新建分析。请删除某些分析后重试，谢谢！</p> <br>
        <p>点击关闭按钮，前往分析列表</p>
      </div>

    </el-dialog>
    <LoadingDialog v-if="isShowAddLoading" :showDialog="isShowAddLoading"
                   :dialogMessage="showAddLoadingMess"></LoadingDialog>
    <!--    分组至少为两个的弹框提示-->
    <!--    <my-result icon="warning" :title="myResultTitle" sub-title="" v-show="showMyResult">-->
    <!--      <div style="width:  250px; display: flex; justify-content: space-between">-->
    <!--        <el-button type="primary" size="medium" @click="$router.push('/groupFile?projectId=' + projectId)">-->
    <!--          上传分组文件-->
    <!--        </el-button>-->
    <!--        <el-button type="primary" size="medium" @click="showMyResult = false">返回</el-button>-->
    <!--      </div>-->
    <!--    </my-result>-->
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {checkIsColor, downloadBlob} from '@/utils/utils'
import MyResult from '@/components/MyResult'
import {downloadProgress} from '@/mixins/downloadProgress.js'
import TaskLog from '@/components/TaskLog'
import {defaultColor} from '@/utils/PublicConstant'
import Analyze from "@/views/systemFunc/project/projectIndex/projectFunc/Analyze";
import QuitProject from '@/components/QuitProject'
import Upload from '@/components/Upload'
import MyProgress from '@/components/Progress'
import LoadingDialog from "@/components/LoadingDialog";
import {envSize} from '@/utils/uploadFileSize'
import {checkMd5} from "@/utils/burstUpload";
import Draggable from "@/components/Draggable";

export default {
  mixins: [downloadProgress],
  components: {
    LoadingDialog,
    'pagination': Pagination,
    'my-result': MyResult,
    'upload': Upload,
    "quit-project": QuitProject,
    'task-log': TaskLog,
    'draggable': Draggable
  },
  data() {
    return {
      filterSample: '',
      checkAllSample: false,
      isIndeterminateSample: true,
      allSamples: [],
      isGroup: true,
      groupNameMaxLength: '',
      groupNameMaxLengthTemp: '',
      otuMinTime: '',
      otuMinPercent: '',
      isShowAddLoading: false,
      showAddLoadingMess: '',
      isIndeterminate: true,
      checkedEnv: false,
      checkAllGroup: false,
      log: {
        showTaskLog: false,
        logContent: ""
      },
      loadingAnalyze: true,
      computeMethod: [{
        label: "Bray_Curtis",
        value: "bc"
      }, {
        label: "Unweighted_Unifrac",
        value: "uu"
      }, {
        label: "Weighted_Unifrac",
        value: "wu"
      }
      ],
      updatedAnalyze: {
        analyzeId: '',
        analyzeName: '',
        showAnalyzeName: ''
      },
      downloadUrl: '../',
      showMyResult: false,
      myResultTitle: '没有合适的分组',
      groupAddForm: {
        groups: [],
        function: 'bc',
        groupColor: [],
      },
      uploadEnvProperty: {
        fileSize: envSize,
        types: new Set(['txt'])
      },
      showGroupSample: '',
      groupsSampleData: '',
      projectId: '',
      analyzeData: [],
      analyzePageChildMsg: {
        total: 0,
        pageSize: 8,
        currentNum: 1
      },
      analyzeDataPageparm: {
        currentNum: 1,
        pageSize: 8
      },
      showUpdateAnalyzeNameDialog: false,
      defaultColor: defaultColor,
      analysisOver: true,
      analysisNum: 0,
      isAnalysisOver: false,
      checkGroup: false,
      analyzeName: '',
      loading: true,
      errColor: [],
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577',
        '#d87c7c',
        '#919e8b',
        '#d7ab82',
        '#6e7074',
        '#111111',
        '#ffffff',
      ],
      checkedSample: [],
      filterSamples: []
    }
  },
  watch: {
    //监听搜索样本名
    filterSample: {
      handler(newD) {
        if (newD === "") {
          this.filterSamples = this.allSamples;
        } else {
          this.filterSamples = this.allSamples.filter((item) => {
            return item.includes(newD);
          });
        }
      },
    }
  },

  created() {
    this.projectId = this.$route.query.projectId
    var projectAll = this.$store.getters['right/getUser']
    if (!this.projectId && projectAll && projectAll.projectsRow) {
      this.projectId = projectAll.projectsRow.projectId
    }
    let that = this
    this.updateIsAnalysisOver().then(x => {
      that.loading = false
      if (that.analysisOver) {
        // that.isAnalysisOver = true
        this.$confirmUi('抱歉，您的分析数已达20条，不能新建分析。请删除某些分析后重试，谢谢！', '提示', {
          confirmButtonText: '前往分析列表',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
        }).then(() => {
          this.closeIsAnalysisOver()
        })
      }
    })
    this.analyzeName = this.getAnalyzeName()
  },
  mounted() {
    this.showAddAnalyzeDialog()
  },

  methods: {
    //选择是否分组
    handleIsGroup(val) {
      if (!val) {
        // 无分组
        this.getGroupNameMaxLength([])
        this.checkedSample = []
        this.checkAllSample = false
        this.isIndeterminateSample = true
        this.filterSamples = this.allSamples
      } else {
        this.checkAllGroup = false
        this.checkGroup = false
        let that = this
        this.isUpLoadGroupFile().then(() => {
          if (that.isGroup) {
            that.groupAddForm.groups = []
            that.groupAddForm.groupColor = []
            that.groupNameMaxLength = JSON.parse(JSON.stringify(this.groupNameMaxLengthTemp))
          }
        })
      }
    },
    getGroupNameMaxLength(sample) {
      let i = 0
      let groupColorSample = []
      let sampeNameLength = []
      sample.forEach(item => {
        groupColorSample.push({
          color: this.defaultColor[i++],
          groupName: item,
        })
        sampeNameLength.push(item.length)
      })
      const SampeNameLengthMax = Math.max(...sampeNameLength)
      this.groupNameMaxLength = SampeNameLengthMax * 8
      this.groupNameMaxLengthTemp = JSON.parse(JSON.stringify(this.groupNameMaxLength))
      this.groupAddForm.groupColor = groupColorSample
    },
    //分组全选
    handleCheckAllChange(val) {
      this.groupAddForm.groups = val ? this.showGroupSample : [];
      if (val) {
        this.groupChooseChange(this.showGroupSample)
      } else {
        const temGroup = []
        this.groupChooseChange(temGroup)
      }
      this.isIndeterminate = false;
    },
    // 样本全选
    handleCheckAllSample(val) {
      this.checkedSample = val ? this.allSamples : []
      this.getGroupNameMaxLength(this.checkedSample)
      this.isIndeterminateSample = false;
      this.checkAllSample = val
    },
    clearInput() {
      this.filterSample = '';
    },
    sampleChooseChange(sample) {
      this.getGroupNameMaxLength(sample)
    },
    //判断选择的颜色是否合法
    checkIsColor(color) {
      return checkIsColor(color)
    },
    //截取样本名
    showGroupExceed(sampleNames) {
      if (sampleNames.length >= 4) {
        return sampleNames.slice(0, 4).join(',')
      } else {
        return sampleNames.join(',')
      }
    },
    //随机生成的分析名
    getAnalyzeName() {
      let time = (new Date()).toLocaleString()
      time = time.replaceAll('/', '').replaceAll(':', '').replaceAll(' ', '')
      return 'Analyze' + time
    },
    //分析数超过20条即跳转分析界面
    closeIsAnalysisOver() {
      this.$router.push('/analyze?projectId=' + this.projectId)
    },
    //重置新增分析的内容
    resetAnalyze() {
      this.groupAddForm.groups = []
      this.groupAddForm.groupColor = []
      // this.groupAddForm.function = 'bc'
      this.groupAddForm.envFile = ''
      this.checkedEnv = false
      this.otuMinPercent = ''
      this.otuMinTime = ''
    },
    //获取环境因子的文件
    getEnvFile(file) {
      var that = this
      if (!file) {
        this.groupAddForm.envFile = ''
      } else {
        that.groupAddForm.envFile = file
      }
    },
    //分组的一个一个的选择
    groupChooseChange(groups) {
      const temArr = []
      groups.forEach(item => {
        item.simpleNames.forEach(sample => {
          temArr.push(sample)
        })
      })
      const set = new Set(temArr)
      const repeatArr = []//重复的元素
      if (set.size != temArr.length) {
        var count = {};
        temArr.forEach(item => {
          if (count[item]) {
            repeatArr.push(item)
          } else {
            count[item] = 1
          }
        })
        var repeatGroup = []
        if (repeatArr.length > 0) {
          //有重复的
          repeatArr.forEach(repeat => {
            var i = []
            groups.map(item => {
              if (item.simpleNames.includes(repeat)) {
                i.push(item.groupName)
              }
            })
            repeatGroup.push({
              repeat, i
            })
          })
        }
        if (groups.length === this.showGroupSample.length) {
          this.checkAllGroup = false
          this.groupAddForm.groups = []
        }
        this.groupAddForm.groups.pop()
        var errArr = []
        repeatGroup.forEach(item => {
          errArr.push(`${item.repeat}同时存在于${item.i.toString()}中；`)
        })
        var errMess = errArr.join("\n")
        const h = this.$createElement
        this.$confirmUi('', {
          message: h('div', null, [
            h('i', {class: 'el-icon-warning', style: 'color:#f36f70;font-size:30px;'}),
            h('span', {style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;'}, '提示'),
            h('p', {style: 'margin:10px 0 0 40px;'}, `新建分析时，一个样本只允许存在在一个组内，请选择其他组或者修改组内样本。`),
            h('p', {style: 'margin:10px 0 0 40px;'}, `提示：${errMess}`)
          ]),
          confirmButtonText: '知道了',
          customClass: 'del-model',
          showClose: false,
          showCancelButton: false,
          closeOnPressEscape: false,
        })
      } else {
        this.checkedSample = groups
        if (groups.length > 0) {
          this.checkGroup = true
        } else {
          this.checkGroup = false
        }
        this.checkAllGroup = groups.length === this.showGroupSample.length
        this.isIndeterminate = groups.length > 0 && groups.length < this.showGroupSample.length;
        var i = 0
        var finishLoop = false
        var defaultLen = this.defaultColor.length
        var tempSet = new Set
        groups.forEach(group => {
          tempSet.add(group.groupId)
        })
        var newGroupColor = []
        var colorSet = new Set
        var existsGroupId = new Set
        this.groupAddForm.groupColor.forEach(item => {
          if (tempSet.has(item.groupId)) {
            newGroupColor.push(item)
            colorSet.add(item.color)
            existsGroupId.add(item.groupId)
          }
        })
        groups.forEach(item => {
          if (!finishLoop) while (i < defaultLen && colorSet.has(this.defaultColor[i])) i++;
          if (i >= defaultLen) {
            i = 0
            finishLoop = true
          }
          if (!existsGroupId.has(item.groupId)) {
            newGroupColor.push({
              groupId: item.groupId,
              groupName: item.groupName,
              color: this.defaultColor[i]
            })
            tempSet.add(this.defaultColor[i++])
          }
        })
        this.groupAddForm.groupColor = newGroupColor
      }
    },
    //准备新增分析，对分析内容检查
    prepareAddAnalyze() {
      var that = this
      this.checkGroupSample().then(res => {
          that.addAnalyzeDialog = false
          that.createAnalyze()}).catch(err => {
        that.$messageUi.error(err)
      })
      // this.$validator.validateAll().then(result => {
      //   if (result) {
      //     let flag = this.errColor.filter(item => item === true)
      //     if (flag.length > 0) {
      //       this.$messageUi.error('颜色格式错误')
      //     } else {
      //       if (this.checkedEnv && !(this.groupAddForm.envFile)) {
      //         this.$messageUi.error("环境因子文件未上传,请检查是否要上传环境因子")
      //       } else {
      //         if (this.isGroup) {
      //           this.checkGroupSample().then(res => {
      //             that.addAnalyzeDialog = false
      //             that.createAnalyze()
      //           }).catch(err => {
      //             that.$messageUi.error(err)
      //           })
      //         } else {
      //           if (this.checkedSample.length < 3) {
      //             that.$messageUi.error('至少选择3个样本')
      //             return;
      //           }
      //           that.addAnalyzeDialog = false
      //           that.createAnalyze()
      //         }
      //       }
      //     }
      //   } else {
      //     this.$messageUi.error('有参数不合法，请检查')
      //     return
      //   }
      // })
    },
    //分组和样本名的检查
    checkGroupSample() {
      var that = this
      return new Promise(function (resolve, reject) {
        if (that.groupAddForm.groups.length < 2) {
          reject('至少选择两组')
        }
        const sampleSet = new Set(that.groupsSampleData.sampleNames)
        if (sampleSet.size != that.groupsSampleData.sampleNames.length) {
          reject('样本名重复')
        }
        var groups = that.groupAddForm.groups
        var checkSimpleSet = new Set
        groups.forEach((item, index) => {
          item.simpleNames.forEach(sample => {
            if (checkSimpleSet.has(sample)) {
              reject('样本名' + sample + '重复')
            }
            checkSimpleSet.add(sample)
            if (!sampleSet.has(sample)) {
              reject('样本名' + sample + '在样本中不存在')
            }
          })
        })
        checkSimpleSet.forEach(item =>
          console.log(item + "检查"))
        resolve()
      })
    },
    //判断有无分组，无分组提示上传分组文件
    async showAddAnalyzeDialog() {
      this.initAddAnalyzeForm()
      await this.getGroupsSampleNames()
      this.groupAddForm.groupIds = []
      this.isUpLoadGroupFile()
      this.addAnalyzeDialog = true
    },
    //当选择有分组时，但并未上传分组文件，提示上传分组文件
    isUpLoadGroupFile() {
      return new Promise((resolve, reject) => {
        if (this.showGroupSample.length <= 1) {
          if (this.showGroupSample.length == 0) {
            this.myResultTitle = '没有合适的分组'
            // const confirmText = ['如需进行分组比较分析，请先在“分组管理”中上传分组文件;', '如无需分组比较，请选择“创建无分组分析”']
            const confirmText = ['目前暂无分组文件，请先在“分组管理”中上传分组文件后再新建分析']
            const newDatas = []
            const h = this.$createElement
            for (const i in confirmText) {
              newDatas.push(h('p', null, confirmText[i]))
            }
            this.$confirmUi('提示', {
              message: h('div', null, newDatas),
              confirmButtonText: '前往分组管理',
              // cancelButtonText: '创建无分组分析',
              type: 'warning',
              closeOnClickModal: false,
              showCancelButton:false,
              showClose: false,
            }).then(() => {
              this.$router.push('/groupFile?projectId=' + this.projectId)
            }).catch(() => {
              this.isGroup = false
              this.handleIsGroup(false)
            })
          } else {
            this.myResultTitle = '有效组数为1，至少需要两组'
          }
          this.showMyResult = true
        }
        resolve()
      })
    },
    initAddAnalyzeForm() {
      this.groupAddForm.groups = []
      this.groupAddForm.groupColor = []
      // this.groupAddForm.function = 'bc'
    },
    //获取该项目的分组信息
    async getGroupsSampleNames() {
      var that = this
      const res = await this.$http.get('group/projectId/' + this.projectId)
      return new Promise((resolve, reject) => {
        if (res) {
          if (res.code === 200) {
            that.groupsSampleData = res.data
            this.allSamples = res.data.sampleNames
            var groupData = that.groupsSampleData.groups
            var len = groupData.length
            var showGroupSample = []
            var groupNameLength = []
            var samples = that.groupsSampleData.sampleNames
            for (var i = 0; i < len; i++) {
              var group = groupData[i]
              var normalSimpleName = group.groupSample.split(',').filter(sampleName => {
                return samples.indexOf(sampleName) >= 0
              })
              if (normalSimpleName.length > 0) {
                showGroupSample.push({
                  groupName: group.groupName,
                  simpleNames: normalSimpleName,
                  groupId: group.groupId
                })
                groupNameLength.push(group.groupName.length)
              }
            }
            that.showGroupSample = showGroupSample
            let groupNameMaxLength = Math.max(...groupNameLength)
            this.groupNameMaxLength = groupNameMaxLength * 14
          }
          resolve()
        } else {
        }

      })
    },
    //新增分析
    async createAnalyze() {
      var groups = this.groupAddForm.groups
      var groupIds = []
      let groupOrder = []
      // let sampleAllLength = 0
      groups.forEach(item => {
        groupIds.push(item.groupId)
        // sampleAllLength += item.simpleNames.length
      })
      // let temGroup = []
      // if (this.isGroup) {
      //   //有分组
      //   this.groupAddForm.groupColor.forEach(item => {
      //     groupOrder.push(item.groupName)
      //   })
      //   temGroup = JSON.parse(JSON.stringify(this.groupAddForm.groupColor))
      // } else {
      //   //无分组
      //   let temArr = this.groupAddForm.groupColor.filter(item => this.checkedSample.indexOf(item.groupName) > -1)
      //   temArr.forEach(item => {
      //     groupOrder.push(item.groupName)
      //     temGroup.push(item)
      //   })
      //   // let temGroup = JSON.parse(JSON.stringify(this.groupAddForm.groupColor))
      // }
      // temGroup.sort((a, b) => {
      //   var value1 = a.groupName;
      //   var value2 = b.groupName;
      //   if (value1 < value2) {
      //     return -1;
      //   } else if (value1 > value2) {
      //     return 1;
      //   } else {
      //     return 0;
      //   }
      // })
      // let groupColor = temGroup.map(item => item.color)
      // var loading = this.$showPublicLoading()
      this.isShowAddLoading = true
      this.showAddLoadingMess = "分析新建中，请稍等......"
      // let otuMinTime = 0
      // let otuMinPercent = 0
      // if (this.otuMinTime) {
      //   if (sampleAllLength < this.otuMinTime) {
      //     this.$messageUi.error('OTU出现在所有样本中的最小次数阈值不能大于所选分组的总样本数')
      //     this.isShowAddLoading = false
      //     return
      //   }
      //   if (this.otuMinTime)
      //     otuMinTime = +this.otuMinTime
      // }
      // if (this.otuMinPercent) {
      //   otuMinPercent = +this.otuMinPercent
      //   otuMinPercent = otuMinPercent.toFixed(4)
      // }
      var sendData = {
        'projectId': this.projectId,
        // 'sampleNames': groupOrder,
        'groupIds': groupIds,
        // 'param': {
        //   'groupColor': groupColor.join(":"),
        //   'groupOrder': groupOrder.join(":")
        // },
        // 'init': {
        //   'otuMinTime': otuMinTime,
        //   'otuMinPercent': (otuMinPercent * 1e4) / 1e6
        // },
        // 'function': this.groupAddForm.function,
        'name': this.analyzeName,
        // 'nonGroup': !this.isGroup
      }
      // if (this.isGroup) {
      //   sendData.groupIds = groupIds
      // }
      // if (this.groupAddForm.envFile) {
      //   const resobj = await checkMd5(this.groupAddForm.envFile)
      //   sendData.envFile = {
      //     'fileName': resobj.fileName,
      //     'hash': resobj.file_md5
      //   }
      // }
      const res = await this.$http.post('analyze', sendData, {}).catch(err => {
        this.$messageUi.error("创建失败")
        this.isShowAddLoading = false
      })
      if (res) {
        if (res.code === 200) {
          this.$messageUi.success('创建成功')
          this.isShowAddLoading = false
          this.$router.push('/analyze?projectId=' + this.projectId)
          this.analyzeName = this.getAnalyzeName()
          this.resetAnalyze()
        } else {
          this.$messageUi.error(res.message)
        }
        await this.updateIsAnalysisOver()
      } else {
        this.isShowAddLoading = false
      }
    },
    //判断分析数是否到达20条
    async updateIsAnalysisOver() {
      const res = await this.$http.get('/project/analysisNum/' + this.projectId)
      if (res) {
        this.analysisNum = res.data
        if (res.data <= 20) {
          this.analysisOver = false
        } else {
          this.analysisOver = true
        }
      }
    },
    handleDragStart(e, item) {
      this.dragging = item
    },
    handleDragEnd(e, item) {
      if (this.ending.groupName === this.dragging.groupName) {
        return;
      }
      let newItems = [...this.groupAddForm.groupColor]
      const src = newItems.indexOf(this.dragging)
      const dst = newItems.indexOf(this.ending)
      newItems.splice(src, 1, ...newItems.splice(dst, 1, newItems[src]))
      console.log(newItems)

      this.groupAddForm.groupColor = newItems
      this.$nextTick(() => {
        this.dragging = null
        this.ending = null
      });
    },
    handleDragOver(e) {
      // 首先把div变成可以放置的元素，即重写dragenter/dragover
      // 在dragenter中针对放置目标来设置
      e.dataTransfer.dropEffect = "move"
    },
    handleDragEnter(e, item) {
      // 为需要移动的元素设置dragstart事件
      e.dataTransfer.effectAllowed = "move"
      this.ending = item
    },
    handleMoveUp(item) {
      let newItems = [...this.groupAddForm.groupColor]
      let index = newItems.indexOf(item)
      newItems.splice(index, 1, ...newItems.splice(index - 1, 1, item))
      this.groupAddForm.groupColor = newItems
    },
    handleMoveDown(item) {
      let newItems = [...this.groupAddForm.groupColor]
      let index = newItems.indexOf(item)
      newItems.splice(index, 1, ...newItems.splice(index + 1, 1, item))
      console.log(newItems)
      this.groupAddForm.groupColor = newItems
    },
  }
}
</script>
<style scoped>
.el-breadcrumb {
  margin-bottom: 20px;
}

.btn-width-setting {
  width: 80px;
}

.box-card {
  margin: 20px 0;
}

.checkbox-setting {
  width: 100%;
  padding: 0 3px !important;
  margin: 8px 0 !important;
  display: flex;
  align-items: center;

}

.el-checkbox-group {
  max-height: 400px;
  overflow: auto;
}

.groupadd-checkbox-col {
  max-width: 300px;
}

.setting-text-one-row {
  display: flex;
  align-items: center;
}

.setting-btn-bgc:hover {
  background-color: rgba(0, 0, 0, .1);
  border-radius: 50%;
}

.status-public {
  line-height: 30px;
  height: 30px;
  width: 80px;
  color: #fff;
  text-align: center;
  border-radius: 20px;
}

.not-execute {
  background-color: #67c23a;
}

.executing {
  background-color: #409eff;
}

.execute-faild {
  background-color: #f56c6c;
}

#analysisNumText {
  font-size: 14px;
  height: 10px;
  align-content: center;
  margin-bottom: 20px;
}

.dialog-footer {
  margin-left: 30%;
  margin-top: 50px;
}

.el-breadcrumb {
  line-height: 40px;
}

.errMess {
  color: #933535;
  margin-left: 10px;
  font-size: 15px;
  width: 160px;
  font-family: "Microsoft YaHei";
}

.wenHaoValue {
  font-family: "Microsoft YaHei";
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 30px;
  padding: 0px 12px 0px 0px;
  box-sizing: border-box;
  margin: 0px;
}

.input-wrapper {
  display: flex;
  align-items: center;
  height: 80px;
}

/deep/ .el-message-box {
  width: 450px !important;
}

.errMess {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 0px;
  position: absolute;
  top: 100%;
  left: 0;
}

.move-up-button {
  padding: 10px;
  height: 40px;
  margin-left: 10px
}
</style>
